import { cn } from "@/shared/lib/cn";

export type NotificationPanelTab = "all" | "unread" | "needs_action";

const TABS: { id: NotificationPanelTab; label: string }[] = [
  { id: "all", label: "All" },
  { id: "unread", label: "Unread" },
  { id: "needs_action", label: "Needs action" },
];

interface NotificationPanelTabsProps {
  active: NotificationPanelTab;
  onChange: (tab: NotificationPanelTab) => void;
  needsActionTotal: number;
}

export function NotificationPanelTabs({
  active,
  onChange,
  needsActionTotal,
}: NotificationPanelTabsProps) {
  return (
    <div
      className="mx-4 my-2 flex gap-1 rounded-lg bg-muted/80 p-1"
      role="tablist"
      aria-label="Notification filters"
    >
      {TABS.map((tab) => {
        const selected = active === tab.id;
        const showCount = tab.id === "needs_action" && needsActionTotal > 0;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(tab.id)}
            className={cn(
              "min-w-0 flex-1 rounded-md px-2 py-1.5 text-2xs font-medium transition-colors",
              selected
                ? "bg-card text-foreground shadow-sm"
                : "text-muted-foreground hover:text-foreground",
            )}
          >
            <span className="truncate">
              {tab.label}
              {showCount ? ` ${needsActionTotal}` : ""}
            </span>
          </button>
        );
      })}
    </div>
  );
}
